import { globalEntitlements } from '../utils/globalEntitlements';

export const BUSINESS_LICENSES_CONFIG = {
  hero: {
    buyBox: [{
      bulletPoints: [
        { title: 'productPage.businessLicenses.buyBox.bulletPoint1' },
        { title: 'productPage.businessLicenses.buyBox.bulletPoint2' },
        { title: 'productPage.businessLicenses.buyBox.bulletPoint3' },
        { title: 'productPage.businessLicenses.buyBox.bulletPoint4' }
      ],
      productName: 'productPage.businessLicenses.buyBox.productName',
      interactService: {
        service: 'business_licenses'
      }
    }],
    headerPicture: {
      src: '/s2/raster/approved-stamp-document.png',
      alt: 'productPage.businessLicenses.heroPicture.altText',
      objectPosition: 'center'
    },
    headline: 'productPage.businessLicenses.page.headline',
    partnerLogo: {
      src: '/s2/vector/partnership-avalara.svg',
      alt: ''
    },
    partnerReviewBlanks: [],
    pill: {
      text: 'productPage.businessLicenses.page.headlinePill',
      bgcolor: 'background.orange.light'
    },
    subheader: 'productPage.businessLicenses.page.subheader'
  },
  benefit: {
    title: 'productPage.businessLicenses.valueProp.title',
    items: [
      {
        icon: '/s2/material-icons/accesstimerounded.svg',
        title: 'productPage.businessLicenses.valueProp.propTitle1',
        description: 'productPage.businessLicenses.valueProp.shortCopy1'
      },
      {
        icon: '/s2/material-icons/attachmoneyrounded.svg',
        title: 'productPage.businessLicenses.valueProp.propTitle2',
        description: 'productPage.businessLicenses.valueProp.shortCopy2'
      },
      {
        icon: '/s2/material-icons/thumbuprounded.svg',
        title: 'productPage.businessLicenses.valueProp.propTitle3',
        description: 'productPage.businessLicenses.valueProp.shortCopy3'
      }
    ]
  },
  howItWorks: {
    title: 'productPage.businessLicenses.howItWorks.title',
    items: [
      {
        title: 'productPage.businessLicenses.howItWorks.step1',
        description: 'productPage.businessLicenses.howItWorks.shortDescription1'
      },
      {
        title: 'productPage.businessLicenses.howItWorks.step2',
        description: 'productPage.businessLicenses.howItWorks.shortDescription2'
      },
      {
        title: 'productPage.businessLicenses.howItWorks.step3',
        description: 'productPage.businessLicenses.howItWorks.shortDescription3'
      }
    ],
    image: '/s2/raster/blr-avalara-dashboard-mockup.png',
    alt: 'productPage.businessLicenses.howItWorks.altText',
    hasNumber: true,
    hasDivider: false,
    hasMobileImage: true
  },
  whatsIncluded: {
    title: 'productPage.businessLicenses.whatsIncluded.title',
    items: [
      {
        title: 'productPage.businessLicenses.whatsIncluded.item1',
        description: 'productPage.businessLicenses.whatsIncluded.item1ShortDescription'
      },
      {
        title: 'productPage.businessLicenses.whatsIncluded.item2',
        description: 'productPage.businessLicenses.whatsIncluded.item2ShortDescription'
      },
      {
        title: 'productPage.businessLicenses.whatsIncluded.item3',
        description: 'productPage.businessLicenses.whatsIncluded.item3ShortDescription'
      },
      {
        title: 'productPage.businessLicenses.whatsIncluded.item4',
        description: 'productPage.businessLicenses.whatsIncluded.item4ShortDescription'
      },
      {
        title: 'productPage.businessLicenses.whatsIncluded.item5',
        description: 'productPage.businessLicenses.whatsIncluded.item5ShortDescription'
      },
      {
        title: 'productPage.businessLicenses.whatsIncluded.item6',
        description: 'productPage.businessLicenses.whatsIncluded.item6ShortDescription'
      },
      {
        title: 'productPage.businessLicenses.whatsIncluded.item7',
        description: 'productPage.businessLicenses.whatsIncluded.item7ShortDescription'
      }
    ],
    image: '/s2/raster/retail-owner-transaction.png',
    alt: 'productPage.businessLicenses.whatsIncluded.altText',
    hasDivider: true,
    hasNumber: false,
    hasMobileImage: false
  },
  faqs: {
    title: 'productPage.businessLicenses.frequentlyAskedQuestions.title',
    items: [
      {
        question: 'productPage.businessLicenses.frequentlyAskedQuestions.faq1',
        answer: 'productPage.businessLicenses.frequentlyAskedQuestions.faqAnswer1'
      },
      {
        question: 'productPage.businessLicenses.frequentlyAskedQuestions.faq2',
        answer: 'productPage.businessLicenses.frequentlyAskedQuestions.faqAnswer2'
      },
      {
        question: 'productPage.businessLicenses.frequentlyAskedQuestions.faq3',
        answer: 'productPage.businessLicenses.frequentlyAskedQuestions.faqAnswer3'
      }
    ]
  },
  assistance: {
    title: 'productPage.businessLicenses.needAssistance.title',
    getInTouch: 'productPage.businessLicenses.needAssistance.getInTouch',
    actions: 'productPage.businessLicenses.needAssistance.actions'
  },
  getBuyButtonConfig: globalEntitlements({ ctaText: 'productPage.businessLicenses.buyBox.buttonLabel.notPurchased' })
    .customCtaTextHasRelatedServices(
      ['business_license_filing', 'business_license_report'],
      'productPage.businessLicenses.buyBox.buttonLabel.purchased'
    )
    .build()
};
